module.exports = __webpack_public_path__ + "img/youtube.cb7b4178.svg";